module.exports = __webpack_public_path__ + "img/image 16.1860422c.png";